export const themeColor: any = {
  primary: {
    main: "#3c7bf6",
  },
  whiteColor: "#ffffff",
  iconsColor: "#39475B",
};
